import React, { useEffect } from 'react'
import api from 'helpers/api'
import { ICeleryStats } from 'types'
import { secondsToHms } from '../../helpers/utils'
import { Table } from 'components/table'

const CeleryStats: React.FC = () => {
  const [stats, setStats] = React.useState<ICeleryStats>()

  const fetchCeleryStats = async () => {
    const response = await api.getCeleryStats()
    setStats(response.data)
  }

  useEffect(() => {
    fetchCeleryStats()
    document.title = 'Morta | Celery Stats'
  }, [])

  return (
    <div className="h-full w-full overflow-auto p-4">
      <div className="mt-5">
        <h3 className="mb-2.5">Queues</h3>
        <Table
          data={
            stats
              ? stats.queues.map((queue) => {
                  return {
                    name: {
                      label: queue.name,
                      value: queue.name
                    },
                    pending: {
                      label: queue.pending,
                      value: queue.pending
                    },
                    active: {
                      label: queue.active['total'],
                      value: queue.active['total']
                    },
                    active_task_args: {
                      label: queue.active['tasks']
                        .map(
                          (entry: { args: any; name: string }) => `${entry['name'].split('.').pop()}(${entry['args']})`
                        )
                        .join('\n'),
                      value: queue.active['tasks']
                        .map(
                          (entry: { args: any; name: string }) => `${entry['name'].split('.').pop()}(${entry['args']})`
                        )
                        .join('\n')
                    },
                    reserved: {
                      label: queue.reserved,
                      value: queue.reserved
                    }
                  }
                })
              : []
          }
          include={[
            { header: 'Queue Name', id: 'name' },
            { header: '# Pending Tasks', id: 'pending' },
            { header: '# Active Tasks', id: 'active' },
            { header: '# Active Tasks Args', id: 'active_task_args' },
            { header: '# Reserved Tasks', id: 'reserved' }
          ]}
          defaultSort={'name'}
          defaultSortAscending={true}
          sort={true}
          loading={!stats}
        />
      </div>

      <div className="mt-5">
        <h3 className="mb-2.5">Workers</h3>

        <Table
          data={
            stats
              ? stats.workers.map((worker) => {
                  return {
                    name: {
                      label: worker.name,
                      value: worker.name
                    },
                    implementation: {
                      label: worker.implementation,
                      value: worker.implementation
                    },
                    accepted: {
                      label: worker.tasks_executed,
                      value: worker.tasks_executed
                    },
                    active: {
                      label: worker.active_tasks,
                      value: worker.active_tasks
                    },
                    reserved: {
                      label: worker.reserved_tasks,
                      value: worker.reserved_tasks
                    },
                    revoked: {
                      label: worker.revoked_tasks,
                      value: worker.revoked_tasks
                    },
                    scheduled: {
                      label: worker.scheduled_tasks,
                      value: worker.scheduled_tasks
                    },
                    uptime: {
                      label: secondsToHms(worker.uptime),
                      value: worker.uptime
                    },
                    max_concurrency: {
                      label: worker.max_concurrency,
                      value: worker.max_concurrency
                    },
                    max_tasks_per_child: {
                      label: worker.max_tasks_per_child,
                      value: worker.max_tasks_per_child
                    },
                    number_of_threads: {
                      label: worker.number_of_threads,
                      value: worker.number_of_threads
                    }
                  }
                })
              : []
          }
          include={[
            { header: 'Worker Name', id: 'name' },
            { header: 'Worker Implementation', id: 'implementation' },
            { header: 'Number of Processes/Threads', id: 'max_concurrency' },
            { header: 'Max Tasks Per Process/Thread', id: 'max_tasks_per_child' },
            { header: 'Threads', id: 'number_of_threads' },
            { header: 'Total # Accepted Tasks', id: 'accepted' },
            { header: '# Active Tasks', id: 'active' },
            { header: '# Reserved Tasks', id: 'reserved' },
            { header: '# Revoked Tasks', id: 'revoked' },
            { header: '# Scheduled Tasks', id: 'scheduled' },
            { header: 'Uptime', id: 'uptime' }
          ]}
          defaultSort={'name'}
          defaultSortAscending={true}
          sort={true}
          loading={!stats}
        />
      </div>
    </div>
  )
}

export default CeleryStats
